import type { BoardGroup } from '../types';

export const mockBoardGroups: BoardGroup[] = [
  {
    id: 'bg-1',
    boardId: 'board-1',
    name: 'Backend',
    description: null,
    order: 0,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: null,
  },
  {
    id: 'bg-2',
    boardId: 'board-1',
    name: 'Design',
    description: null,
    order: 1,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: null,
  },
  {
    id: 'bg-3',
    boardId: 'board-1',
    name: 'Frontend',
    description: null,
    order: 2,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: null,
  },
  {
    id: 'bg-4',
    boardId: 'board-1',
    name: 'Infrastructure',
    description: null,
    order: 3,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: null,
  },
];
